import type { RouteLocationNormalizedGeneric } from '#vue-router'
import type { DemoSlotsPaginatedData } from '@ts-demo-slot/interfaces'
import type { ApiCallbacks } from '@utils/api/run-api-get'

import { useDemoShiftControlStore } from '@stores/demo-shift-control'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { runApiGet } from '@utils/api/run-api-get'
import { pick } from '@helpers/object'
import { getFirstQueryValue, normalizeArrayQuery } from '@helpers/route'

interface SlotsTrackerApiOptions extends ApiCallbacks<DemoSlotsPaginatedData> {
  route?: RouteLocationNormalizedGeneric
}

export const useSlotsTrackerApi = async (options?: SlotsTrackerApiOptions): Promise<DemoSlotsPaginatedData | null> => {
  const route = options?.route || useRoute()
  const demoShiftControlStore = useDemoShiftControlStore()

  const url = useAdminRoutes('admin.demo-slots.tracker', pick({
    from: getFirstQueryValue(route.query?.from) || demoShiftControlStore.getFilterFrom!,
    to: getFirstQueryValue(route.query?.to) || demoShiftControlStore.getFilterTo!,
    statuses: normalizeArrayQuery(route.query?.statuses),
    reservation_types: normalizeArrayQuery(route.query?.reservation_types),
    sort_by: getFirstQueryValue(route.query?.sort_by) || demoShiftControlStore.getFilterSortBy,
    per_page: getFirstQueryValue(route.query?.per_page) || demoShiftControlStore.getPerPage,
    page: getFirstQueryValue(route.query?.current_page) || demoShiftControlStore.getCurrentPage,
  }))

  return runApiGet<DemoSlotsPaginatedData>(url, {
    setLoading: (loading) => demoShiftControlStore.setLoading(loading),
    handle: (response) => {
      const paginatedData: DemoSlotsPaginatedData | null = response?.data || null
      demoShiftControlStore.setSlotsPaginatedData(paginatedData)
      return paginatedData
    },
    hooks: options,
  })
}
